
import { reactive, ref, toRefs, unref, onMounted, defineComponent } from "vue";
//引入vue方法
import Edit from "./Edit.vue";
import { ElConfigProvider } from "element-plus";
//中文包
import zhCn from "element-plus/lib/locale/lang/zh-cn";
import { getParameterList, delParametert } from "@/api/backstage";
import { ElMessage } from "element-plus";
import { ElForm } from "element-plus";
type FormInstance = InstanceType<typeof ElForm>;

export default defineComponent({
  name: "系统参数",
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    Edit,
  },
  setup() {
    let locale = zhCn;
    const ruleFormRef = ref(ElForm);
    const dataMap: any = reactive({
      dialogVisible: false,
      ruleFormRef: ref<FormInstance>(),
      rows: "",
      tableData: [],
      total: 0,
      time: "",
      form: {
        title: "",
        pageNum: 1,
        pageSize: 10,
      },
      async getList() {
        const data = await getParameterList(this.form);
        dataMap.tableData = data?.data.list ?? [];
        dataMap.total = data?.data.total ?? 0;
      },
      async delMenu(ids: any) {
        const baseId = { id: ids };
        const res = await delParametert(baseId);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
          dataMap.getList();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });
    const onSubmit = () => {
      dataMap.getList();
    };

    const resetForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataMap.getList();
    };

    const handleSizeChange = (val: number) => {
      dataMap.form.pageSize = val;
      dataMap.getList();
    };
    const handleCurrentChange = (val: number) => {
      dataMap.form.pageNum = val;
      dataMap.getList();
    };
    const addClick = (row: any) => {
      dataMap.dialogVisible = true;
      dataMap.rows = "";
    };
    const close = (val: any) => {
      dataMap.dialogVisible = false;
      dataMap.getList();
    };
    const editClick = (row: any) => {
      dataMap.rows = row;
      dataMap.dialogVisible = true;
    };
    const confirmEvent = (row: any, index: any) => {
      dataMap.delMenu(row.id);
    };

    onMounted(() => {
      dataMap.getList();
    });

    return {
      locale,
      close,
      onSubmit,
      resetForm,
      editClick,
      addClick,
      confirmEvent,
      handleSizeChange,
      handleCurrentChange,
      ...toRefs(dataMap),
    };
  },
});
